export default {
  methods: {
    swallConfirmation(data){
      return this.$swal({
        showConfirmButton: true,
        showCancelButton: true,
        cancelButtonText: data.cancelButtonText ? data.cancelButtonText : 'Cancelar',
        title: data.title,
        text: data.text,
        icon: data.icon, //[ success, error, warning, info, question]
        customClass: {
          title:'swall_title',
          container:"swall_text",
          cancelButton:'swall_button swall_cancel_button',
          confirmButton:'swall_button swall_confirm_button',
          icon: 'swall_icon'
        },
        confirmButtonText: data.confirmButtonText ? data.confirmButtonText : 'Confirmar',
        reverseButtons:true,
      }).then(r=>{
        return r.value
      });
    },
    swallError(text){
      return this.$swal.fire({
        icon: 'error',
        title: 'Opss... Ocorreu um erro',
        text,
        customClass: {
          title:'swall_title',
          container:"swall_text",
          cancelButton:'swall_button swall_cancel_button',
          confirmButton:'swall_button swall_confirm_button',
          icon: 'swall_icon'
        },
        confirmButtonText:'Confirmar',
      }).then(r =>{
        return r.value
      })
    },
  },
};
